import React, { useEffect, useRef } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { RecordSection } from 'components/record-shell/RecordShell';
import { AccessRule } from 'types/accessRule';
import ProfilePermissions from './ProfilePermissions';

export type ProfileValidation = {
  name?: string;
};

type ProfileFormProps = {
  name: string;
  onNameChange(value: string): void;
  validation: ProfileValidation;
  accessRules: AccessRule[];
  onToggleRule(id: number): void;
};

const ProfileForm: React.FC<ProfileFormProps> = ({ name, onNameChange, validation, accessRules, onToggleRule }) => {
  const nameInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (validation.name) nameInputRef.current?.focus();
  }, [validation]);

  return (
    <Grid container size={12} spacing={2} maxWidth={900}>
      <Grid size={12}>
        <Typography variant="subtitle2" fontWeight={700} color="primary">
          Dados do perfil
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          inputRef={nameInputRef}
          error={!!validation.name}
          helperText={validation.name}
          label="Nome"
          placeholder="Digite o nome do perfil"
          value={name}
          onChange={e => onNameChange(e.target.value)}
          fullWidth
          autoFocus
        />
      </Grid>

      <Grid size={12}>
        <RecordSection title="">
          <ProfilePermissions rules={accessRules.filter(rule => !rule.access_rule_id)} onToggle={onToggleRule} />
        </RecordSection>
      </Grid>
    </Grid>
  );
};

export default ProfileForm;
